import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';

const DashboardContentBox = ({ title, width, bodyHeight, children }) => {
  return (
    <ContentBox>
      <HeaderArea width={width}>{title}</HeaderArea>
      <BodyArea width={width} bodyHeight={bodyHeight}>
        {children}
      </BodyArea>
    </ContentBox>
  );
};

export default DashboardContentBox;

DashboardContentBox.propTypes = {
  title: PropTypes.string,
  width: PropTypes.string,
  bodyHeight: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
};

const ContentBox = styled(FlexBoxColumn)`
  box-shadow: 0 6px 20px rgba(200, 202, 212, 0.5);
`;

const HeaderArea = styled.div`
  height: 46px;
  width: ${({ width }) => width};
  max-width: ${({ width }) => width};
  color: #ffffff;
  font-size: 16px;
  line-height: 46px;
  padding: 0 20px;
  border-radius: 6px 6px 0 0;
  background-color: #6c60ff;
`;

const BodyArea = styled.div`
  height: ${({ bodyHeight }) => bodyHeight};
  width: ${({ width }) => width};
  max-width: ${({ width }) => width};
  padding: 20px;
  border-radius: 0 0 6px 6px;
  background-color: #ffffff;
`;
